import React from 'react';
import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import {
  CONTENT_SEPARATOR,
  DETAILS_CONTENT_KEYS,
  IPlanContent,
  PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
} from '../typings';
import { PlanKeyDetailsModal } from './common/PlanKeyDetailsModal';
import {
  defaultEstimatesDialog,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
  gasKeyDetailsAddons,
} from './common/planDefaults';
import { EVPowerUpPromobox } from './common/EVPowerUpPromobox';
import { InternetOfferPerk } from './common/internetOfferPerk';

const PLAN_TONE = 'caution';

export const basicGasSignupOptions = [
  'Direct debit optional for hassle-free bill payments',
  'Inbox or letterbox? Your choice for letters and bills',
];

export const basicDefaultSignupOptions = [
  basicGasSignupOptions[0],
  'Your electricity billed monthly or quarterly',
  basicGasSignupOptions[1],
];

export const originBasicContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Basic']),
  content: {
    rateChangePrepositionText: {
      VIC: {
        defaultFuel:
          'Our electricity rates will change on 1 August. You’ll see your new charges on your next bill after that time.',
        gas: '',
      },
      defaultState: {
        defaultFuel: '',
      },
    },
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on an ongoing contract',
      },
    },
    keyFeatures: {
      defaultState: {
        defaultFuel: [
          'The convenience of an ongoing plan – no renewal required',
          'Pay your way - flexible payment options available',
          'Switch your plan at any time without paying any fees',
        ],
      },
    },
    signUpOptions: {
      defaultState: {
        defaultFuel: basicDefaultSignupOptions,
        gas: basicGasSignupOptions,
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: [
          {
            contentKey: DETAILS_CONTENT_KEYS.Rates,
            contentValue: 'Variable',
            modalContent: PlanKeyDetailsModal,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
            contentDescription: 'Variable rates',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.ExitFees,
            contentValue: 'No',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
            contentDescription: 'No exit fees. Leave anytime.',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
            contentValue: 'Ongoing' + CONTENT_SEPARATOR + PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
            contentDescription: 'Ongoing contract',
          },
        ],
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        gas: gasKeyDetailsAddons,
        dual: dualKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    promoBox: {
      defaultState: {
        defaultFuel: [],
        dual: [<EVPowerUpPromobox />],
        electricity: [<EVPowerUpPromobox />],
      },
    },
    promoBoxAuth: {
      defaultState: {
        defaultFuel: [],
        dual: [<EVPowerUpPromobox />],
        electricity: [<EVPowerUpPromobox />],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'grey',
              odsCore: 'neutral',
            },
            promobox: {
              styleGuide: 'lightOrange',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'grey56',
              odsCore: 'neutralDark',
            },
          },
          imageUrl:
            'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/pictograms/pictogram_origin-basic.svg',
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-basic.svg',
            gas: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-basic_gas_2.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-basic.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'Choose energy with variable rates',
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/',
      },
    },
  },
};
